<template>
    <div class="logic-wrap" >
        <el-tooltip class="item" effect="dark" content="Top Center 提示文字" placement="top">
            <el-button size="mini" class="action-btn" @click="toggle">{{data.logic}}</el-button>
            <div slot="content">
                <p>当前：{{data.logic}}</p>
                <p>且：满足所有条件；</p>
                <p>或：满足任一条件；</p>
            </div>
        </el-tooltip>
        <div class="line"></div>
    </div>
</template>

<script>
    export default {
        name: "ConditionLogicBtn",
        props:{
            data:Object,
        },
        inject:['isView'],
        methods:{
            toggle(){
                if(this.isView) return;
                this.$emit('toggle',this.data);
            },
        },
    }
</script>

<style lang="scss" scoped>
    .logic-wrap{
        width: 30px;
        position: absolute;
        left: 15px;
        top: 40px;
        bottom: 45px;
        &:before{
            content: '';
            width: 10px;
            height: 1px;
            background-color: #ccc;
            position: absolute;
            top: 0;
            left: 15px;
        }
        &:after{
            content: '';
            width: 10px;
            height: 1px;
            background-color: #ccc;
            position: absolute;
            bottom: 0;
            left: 15px;
        }

        .line{
            position: absolute;
            top:0;
            bottom: 0;
            left: 50%;
            width: 1px;
            background-color: #ccc;
        }

        .action-btn{
            position: absolute;
            top: 50%;
            padding: 8px;
            z-index: 2;
            margin-top: -15px;
        }

    }
</style>
